/* Code 4 — variant picker: stock-aware option colouring + the
   choose-gate. Served from layout/theme.liquid on every page so the
   quick-add drawer's injected picker is wired too.

   EDIT THIS FILE DIRECTLY. It was first generated by
   code/picker_assets_global.py, but that script is a ONE-TIME MIGRATION and
   is now permanently inert: it exits at "Already applied" because the layout
   already references this asset, and it can no longer find the
   {% javascript %} block it used to lift (that block is gone from the
   snippet). Verified 2026-09-02. Its old "edit that, not this" note sent
   people to a script that cannot run. This file is the source of truth. */
(function () {

  /* Code 4 2026-09-02 (task AW) — WHICH OPTION GROUPS THE SHOPPER ACTUALLY CHOSE.
     Module scope, keyed by product id, and deliberately NOT stored on the
     element: Horizon replaces <variant-picker> wholesale on re-render (that is
     why this file carries __c4*Init guards and a 500ms rescan), so per-element
     state dies exactly when it is needed.

     WHY THIS EXISTS. variant-main-picker.liquid suppresses pre-selection with
     `{% if product_resource.selected_variant == nil %}`, which is true ONLY on
     the first render. One click later Horizon has resolved a variant and
     re-rendered, the guard stops applying, and the template checks a SECOND
     option the shopper never picked -- on the Tek3 EMT pant, clicking Midnight
     Navy silently selected size 28 (0 on hand) and produced a 40-50 business day
     delivery promise while four Navy sizes were in the warehouse.

     Liquid cannot fix it: the template is stateless across re-renders and
     cannot tell a deliberate ?variant= deep link from a mid-flow re-render.
     "Has the shopper chosen this?" is session state, so it lives here. */
  var C4_CHOSEN = Object.create(null);   // pid -> { fieldsetIndex: true }
  var C4_SEEDED = Object.create(null);   // pid -> true
  var C4_LAST   = Object.create(null);   // pid -> last fieldset the shopper clicked

  /* True only while THIS file is driving a radio, so the resulting events are
     not mistaken for the shopper's own choice.

     e.isTrusted is NOT sufficient and that cost a deploy. Measured in Chrome on
     the live page, 2026-09-02: for an element.click(), the CLICK event arrives
     isTrusted:false as expected, but the CHANGE event the browser fires as its
     default action arrives isTrusted:TRUE. So the change handler happily marked
     every auto-completed group as chosen, and clicking a colour with no stock
     then kept the previous size instead of clearing it -- exactly the bug this
     file exists to remove, one layer down.

     Both events fire synchronously inside .click(), so a plain flag spans them. */
  var C4_PROGRAMMATIC = false;

  /* Code 4 — moved out of inline <script> on 2026-08-22 so the picker
     works when it is INJECTED, not just when it is parsed. See
     code/picker_js_theme_level.py for the measurement behind it. */

  function c4InitSwatches(picker) {
          if (picker.__c4DeadComboInit) return;
          picker.__c4DeadComboInit = true;

          var dataEl = picker.querySelector('script[data-c4-variant-combos]');
          var variants;
          try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
          // variants: [{ o: ["34","Gold","Brass"], q: 5 }, ...]
          if (!variants || !variants.length) return;

          function optionInputs() {
            return Array.prototype.slice.call(
              picker.querySelectorAll('input[type="radio"][data-fieldset-index]')
            );
          }

          // Currently checked value per option index (by data-fieldset-index).
          function currentSelection() {
            var sel = [];
            optionInputs().forEach(function (inp) {
              if (inp.checked) {
                sel[parseInt(inp.getAttribute('data-fieldset-index'), 10)] = inp.value;
              }
            });
            return sel;
          }

          // Does a real variant exist with `value` at position `idx`, matching
          // every OTHER currently-selected option? (Unset options are ignored.)
          function comboExists(sel, idx, value) {
            for (var k = 0; k < variants.length; k++) {
              var o = variants[k].o;
              if (String(o[idx]) !== String(value)) continue;
              var ok = true;
              for (var j = 0; j < sel.length; j++) {
                if (j === idx || sel[j] == null) continue;
                if (String(o[j]) !== String(sel[j])) { ok = false; break; }
              }
              if (ok) return true;
            }
            return false;
          }

          // Does the FULL current selection match any real variant?
          function fullSelectionExists(sel) {
            for (var k = 0; k < variants.length; k++) {
              var o = variants[k].o, ok = true;
              for (var j = 0; j < sel.length; j++) {
                if (sel[j] == null) continue;
                if (String(o[j]) !== String(sel[j])) { ok = false; break; }
              }
              if (ok) return true;
            }
            return false;
          }

          // WORST on-hand qty among variants having `value` at `idx`, matching the
          // other currently-selected options. Returns null if no such variant exists.
          //
          // Worst, not best, and that is the whole point of this function. It used
          // to take the MAX, which answers "is this size in stock in SOME width?"
          // -- while the status line below answers "is the variant you actually
          // picked in stock?". On this boot, 13/Wide has 2 and 13/Regular has 0, so
          // MAX painted size 13 green and picking it then said "Made to order --
          // ships in about 40-50 business days", directly above Add to cart (2026-08-22).
          //
          // MIN can only understate: a tile goes green only when EVERY variant
          // still reachable from it ships now, so choosing the remaining options
          // can upgrade a tile but never downgrade one. Same rule the stock tiers
          // in same-day-ship-badge.liquid follow -- never overstate.
          // Returns {min, max} across every variant that has `value` at `idx` and
          // matches the options the shopper HAS set, or null when no such variant
          // exists. Both numbers matter: min alone hid real stock (a Colour x Size
          // pant opened all-khaki because no colour was chosen yet), max alone
          // over-promised (a size went green, then said "Made to order" once
          // picked). The pair lets the tile say "some, not all" instead of lying
          // in one direction or the other.
          // Is ANY variant matching this option actually purchasable?
          //
          // NOT the same question as `q > 0`, and not redundant with it. A
          // variant can exist, carry CONTINUE policy and still be unbuyable:
          // CONTINUE cannot conjure a place to ship FROM, so a variant with no
          // inventory level at "Ship from our Warehouse" reports available:false
          // and Horizon greys the Add-to-cart button. On the Safariland Model 75
          // that is 37 of 42 variants.
          //
          // Before this existed the picker had two states, so those variants
          // were coloured khaki -- "Made to order (~40-50 business days)" -- stayed
          // selectable, and produced a delivery promise followed by a dead
          // button. A promise we then refuse is worse than no promise.
          //
          // true  = at least one matching variant can be bought
          // false = matches exist, none can be bought
          // null  = no matching variant at all (qtyFor returns null too)
          function availFor(sel, idx, value) {
            var seen = false;
            for (var k = 0; k < variants.length; k++) {
              var o = variants[k].o;
              if (String(o[idx]) !== String(value)) continue;
              var ok = true;
              for (var j = 0; j < sel.length; j++) {
                if (j === idx || sel[j] == null) continue;
                if (String(o[j]) !== String(sel[j])) { ok = false; break; }
              }
              if (ok) {
                seen = true;
                // Absent `a` means an older payload; treat as buyable so a
                // stale cache degrades to the previous behaviour, not to
                // hiding the whole range.
                if (variants[k].a !== false) return true;
              }
            }
            return seen ? false : null;
          }

          function qtyFor(sel, idx, value) {
            var lo = null, hi = null;
            for (var k = 0; k < variants.length; k++) {
              var o = variants[k].o;
              if (String(o[idx]) !== String(value)) continue;
              var ok = true;
              for (var j = 0; j < sel.length; j++) {
                if (j === idx || sel[j] == null) continue;
                if (String(o[j]) !== String(sel[j])) { ok = false; break; }
              }
              if (ok) {
                var q = variants[k].q;
                if (lo === null || q < lo) lo = q;
                if (hi === null || q > hi) hi = q;
              }
            }
            return lo === null ? null : { min: lo, max: hi };
          }

          // Reveal one option group at a time: a group stays hidden until every
          // EARLIER group that is a real choice (2+ values) has a value. This is
          // what makes two tile colours honest — with the earlier options
          // settled, a tile in the visible group resolves to a single variant,
          // so green/khaki is the answer rather than a guess across combinations.
          function gateGroups() {
            var fs = Array.prototype.slice.call(
              picker.querySelectorAll('fieldset.variant-option')
            );
            var unlocked = true;
            for (var i = 0; i < fs.length; i++) {
              var radios = fs[i].querySelectorAll('input[type="radio"]');
              fs[i].hidden = !unlocked;
              if (radios.length > 1 &&
                  !fs[i].querySelector('input[type="radio"]:checked')) {
                unlocked = false;
              }
            }
          }

          var c4Pid = picker.getAttribute('data-product-id') || 'default';

          // Seed ONCE per product. Whatever is checked the first time we ever
          // see this picker is legitimate -- a ?variant= deep link, or Horizon's
          // default on a single-option product. Seeding once is the whole trick:
          // re-seeding on a later init would re-bless the phantom selection and
          // restore the bug this fixes.
          if (!C4_SEEDED[c4Pid]) {
            C4_SEEDED[c4Pid] = true;
            var seed = Object.create(null);
            optionInputs().forEach(function (inp) {
              if (inp.checked) {
                seed[parseInt(inp.getAttribute('data-fieldset-index'), 10)] = true;
              }
            });
            C4_CHOSEN[c4Pid] = seed;
          }

          function chosenMap() {
            return C4_CHOSEN[c4Pid] || (C4_CHOSEN[c4Pid] = Object.create(null));
          }

          // Only a REAL interaction marks a group as chosen. e.isTrusted is
          // false for anything script-driven, which is exactly how the
          // auto-complete below clicks a radio without that click counting as
          // the shopper's decision. Without this the auto-completion would
          // mark itself chosen and poison the colouring the same way the
          // phantom size did.
          function markChosen(e) {
            if (C4_PROGRAMMATIC) return;          // our own click, not the shopper's
            if (!e || !e.isTrusted || !e.target || !e.target.closest) return;
            var radio = e.target.matches && e.target.matches('input[type="radio"][data-fieldset-index]')
              ? e.target
              : (e.target.closest('.variant-option__button-label') || document.createElement('div'))
                  .querySelector('input[type="radio"][data-fieldset-index]');
            if (!radio) return;
            var idx = parseInt(radio.getAttribute('data-fieldset-index'), 10);
            if (!isNaN(idx)) { chosenMap()[idx] = true; C4_LAST[c4Pid] = idx; }
          }

          /* Code 4 2026-09-08 — RE-ANCHOR: a click re-opens the groups AFTER it.
             Half of the upstream-scope fix below; neither half works alone.

             Once a later group can no longer disable an earlier one, a click
             can land on a value that contradicts a choice made further down --
             Black while Inseam 30 is selected, on a pant Black only comes in
             34. Without this the shopper swaps one dead end for another: Black
             is now selectable but nothing matches, so applyAuto clears the
             waist and the button falls back to "Select options".

             Releasing lets applyAuto re-complete from autoTarget, which is
             in-stock-only, so the click lands on Black / 30 / 34 with 2 on the
             shelf.

             ONLY the groups after the click, and ONLY when something actually
             contradicts. Dropping choices unconditionally would throw away a
             size that is still perfectly valid every time the shopper looks at
             another colour. */
          function releaseConflicts() {
            var last = C4_LAST[c4Pid];
            if (last == null) return;
            if (fullSelectionExists(chosenSelection())) return;   // nothing contradicts
            var chosen = chosenMap();
            Object.keys(chosen).forEach(function (k) {
              if (parseInt(k, 10) > last) delete chosen[k];
            });
          }

          // The options BEFORE `idx`. Each group is judged only by the groups
          // ahead of it, never by the ones behind -- see recompute().
          function upstream(sel, idx) {
            var up = [];
            for (var j = 0; j < idx; j++) up[j] = sel[j];
            return up;
          }

          // The selection as the SHOPPER made it -- auto-completed groups are
          // excluded on purpose. This is what the colouring reads, so a colour
          // tile keeps its aggregate meaning ("ships now in some size") until a
          // size is genuinely picked.
          function chosenSelection() {
            var chosen = chosenMap(), sel = [];
            optionInputs().forEach(function (inp) {
              var idx = parseInt(inp.getAttribute('data-fieldset-index'), 10);
              if (inp.checked && chosen[idx]) sel[idx] = inp.value;
            });
            return sel;
          }

          // First variant that matches every chosen option AND genuinely ships
          // now. Returns its full option tuple, or null when nothing in stock is
          // reachable from here.
          //
          // IN-STOCK ONLY, and that restriction is the point. Auto-selecting
          // arms Add-to-cart with an option the shopper did not pick; on a
          // made-to-order item there is no way back ("Special-order items are
          // not returnable or refundable"). Limiting it to in-stock paths means
          // anything ever chosen on a shopper's behalf is returnable. Do not
          // "simplify" this to the first value regardless of stock.
          function autoTarget(sel) {
            for (var k = 0; k < variants.length; k++) {
              var v = variants[k], o = v.o, ok = true;
              for (var j = 0; j < sel.length; j++) {
                if (sel[j] == null) continue;
                if (String(o[j]) !== String(sel[j])) { ok = false; break; }
              }
              if (ok && v.a !== false && v.q > 0) return o;
            }
            return null;
          }

          // Drive the unchosen groups toward the target. IDEMPOTENT BY DESIGN:
          // it only acts where the DOM differs from what is wanted, so once
          // Horizon has re-rendered with the target selected this is a no-op.
          // That is what stops the clear/re-resolve/clear flicker loop.
          //
          // At most ONE click per pass -- a click makes Horizon re-render, and
          // the next pass picks up where this left off.
          function applyAuto(sel) {
            var chosen = chosenMap();

            // COMPLETE a selection, never ORIGINATE one. With nothing chosen,
            // autoTarget([]) returns the product's first in-stock variant and we
            // would arm Add-to-cart on a page the shopper has not touched --
            // measured live 2026-09-02: a bare load of the Tek3 pant resolved
            // Midnight Navy / 34 and enabled the button. The whole point of the
            // picker is that the shopper picks deliberately; auto-completion is
            // there to save the SECOND click, not to make the first one.
            if (!Object.keys(chosen).length) return false;
            // ...and not from a picker a re-render has emptied either. After a
            // no-match reload C4_CHOSEN still names the colour group while no
            // radio in it is checked, so autoTarget([]) picked the product's first
            // in-stock variant and Shopify filled in ANOTHER colour, Add to cart
            // armed (XTU pant, 2026-09-14: clicked MultiCam, got Black / 38 / 30).
            if (!sel.some(function (v) { return v != null; })) return false;

            var target = autoTarget(sel), groups = {};
            optionInputs().forEach(function (inp) {
              groups[parseInt(inp.getAttribute('data-fieldset-index'), 10)] = true;
            });
            var pending = null;
            Object.keys(groups).forEach(function (key) {
              var idx = parseInt(key, 10);
              if (chosen[idx]) return;                       // shopper's own choice
              var want = target ? String(target[idx]) : null;
              optionInputs().forEach(function (inp) {
                if (parseInt(inp.getAttribute('data-fieldset-index'), 10) !== idx) return;
                if (want === null) {
                  // Nothing in stock down this path: leave the group empty and
                  // let the choose-gate keep the button on "Select options".
                  if (inp.checked) inp.checked = false;
                } else if (String(inp.value) === want && !inp.checked && !inp.disabled) {
                  if (!pending) pending = inp;
                }
              });
            });
            if (pending) {
              C4_PROGRAMMATIC = true;
              try { pending.click(); } finally { C4_PROGRAMMATIC = false; }
              return true;
            }
            return false;
          }

          function recompute() {
            releaseConflicts();
            var sel = chosenSelection();
            if (applyAuto(sel)) return;   // a click landed; the re-render re-runs us
            // Guard: if the current combo itself is dead (e.g. arrived via a
            // bad URL), don't grey everything — leave all enabled so the
            // shopper can recover by picking something valid.
            var selectionOk = fullSelectionExists(sel);

            optionInputs().forEach(function (inp) {
              var label = inp.closest('.variant-option__button-label');
              if (!label) return;
              var idx = parseInt(inp.getAttribute('data-fieldset-index'), 10);

              /* Code 4 2026-09-08 — UPSTREAM SCOPE. Judge this group by the
                 groups BEFORE it only.

                 It used to be judged by every other selected option, later ones
                 included, and a dead tile is genuinely disabled + pointer-events
                 none. On a sparse grid that traps the shopper: on the UA Expanse
                 pant (12 real SKUs in a 5x3x3 matrix) picking Inseam 30 greyed
                 out Coyote, Black AND Castlerock, and clicking them did nothing
                 -- while Coyote held 5 units and Black 2. Measured 2026-09-08:
                 679 of 3,830 multi-option products can strand an in-stock option
                 this way, 1,685 option values and 46,835 units behind them.

                 Scoping upstream makes the trap structurally impossible rather
                 than merely unlikely: the first group is never disabled by
                 anything, and every later group is disabled only by choices the
                 shopper can still reach and change. Narrowing DOWN the page is
                 kept -- City Khaki genuinely has no waist 32, so that stays
                 greyed. It is narrowing back UP that was wrong. */
              var up = upstream(sel, idx);
              var dead = selectionOk && !inp.checked && !comboExists(up, idx, inp.value);
              label.classList.toggle('c4-dead-combo', dead);
              if (dead) {
                // Genuinely disable so NO input method (click, mousedown,
                // pointerdown, keyboard) can select it. CSS also sets
                // pointer-events:none on the label as a second layer.
                inp.disabled = true;
                inp.setAttribute('aria-disabled', 'true');
                inp.setAttribute('tabindex', '-1');
                label.classList.remove('c4-instock', 'c4-oos');
              } else {
                inp.disabled = false;
                inp.removeAttribute('tabindex');
                // Leave aria-disabled alone when not dead — Horizon may have set
                // it for its own (special-order) styling.

                // Stock-aware color: green when the matching variant has stock,
                // khaki (available to order) when it's 0 on hand.
                var q = qtyFor(sel, idx, inp.value);
                // Two states. `max > 0` is exact for every group after the first,
                // because gateGroups() below keeps a group hidden until the
                // earlier ones are chosen — so by the time these tiles are on
                // screen, each matches exactly one variant. For the FIRST group
                // it aggregates, and means "ships now in some of the rest",
                // which is the useful meaning for a first choice.
                // THREE states, not two. The third exists because "0 on hand"
                // and "cannot be bought" are different facts that used to share
                // the khaki tile -- see availFor() above.
                var av = availFor(sel, idx, inp.value);

                /* Code 4 2026-09-08 — the tile is now reachable but the full
                   selection may not describe it: Black exists, just not with the
                   inseam already picked, so qtyFor returns null and the tile
                   would render uncoloured. Fall back to the upstream meaning --
                   "Black, ignoring the choices this click will re-anchor" --
                   which is the question the shopper is actually asking of a
                   swatch they are about to click.

                   It cannot over-promise. Green here means autoTarget has an
                   in-stock variant to land on, and releaseConflicts + applyAuto
                   then land on exactly that one. Full-selection scope is still
                   tried FIRST, so nothing that resolves today changes colour --
                   the 2026-08-22 min/max fix is untouched. */
                if (q === null) {
                  q = qtyFor(up, idx, inp.value);
                  av = availFor(up, idx, inp.value);
                }
                label.classList.remove('c4-instock', 'c4-unknown', 'c4-oos', 'c4-unavail');
                if (q === null) {
                  // not a real combination — leave it uncoloured
                } else if (av === false) {
                  // Real variant, genuinely unbuyable. Left SELECTABLE on
                  // purpose: disabling every tile on a product where nothing is
                  // buyable would render an inert picker that looks broken. The
                  // tile is marked instead, so it agrees with the button rather
                  // than contradicting it.
                  label.classList.add('c4-unavail');
                } else if (q.max > 0) {
                  label.classList.add('c4-instock');
                } else {
                  label.classList.add('c4-oos');
                }
              }
            });

            gateGroups();
            syncUrl();
          }

          /* Code 4 2026-09-09 — keep ?variant= in step with the FORM.

             HORIZON'S BUG, NOT OURS, and worth writing down because it looks
             like ours. Horizon's variant-picker.js writes the URL from the
             CLICKED RADIO'S OWN `data-variant-id`, and that attribute is a
             per-option-value REPRESENTATIVE id meaning "this value combined
             with the FIRST value of every other option". Measured on the Tek3
             pant 2026-09-09: the `Size 28` radio and the `Colour Black` radio
             carry the SAME id, 56651520508070, because both mean Black/28.

             So the LAST option clicked wins and silently resets every other
             axis to its default:

                 click Midnight Navy -> replaceState Navy/28   size wrong
                 click Size 32       -> replaceState Black/32   COLOUR wrong
                                        last write wins

             The form input stayed correct throughout, so the cart was never
             affected -- but a shared, bookmarked or reloaded link opened the
             wrong colour, usually at 0 stock, with Add to cart armed. Verified
             identical with the pre-fix picker, so auto-complete did not cause
             it; it merely guarantees a second click, which fires it every time.

             The form is authoritative: it is what Add to cart posts. Realign
             the URL to it.

             CANNOT 404 AND CANNOT NAVIGATE. It rewrites only the query string
             of the page already loaded, via replaceState, with an id Shopify
             itself just resolved. No request is made.

             Three guards, each load-bearing:
               - a picker inside the quick-add drawer must never touch the
                 URL; that URL belongs to the collection page behind it.
               - the page we are on must BE this product's page, compared
                 path-to-path against `data-product-url`. **Do not use
                 `data-template-product-match` for this.** It looked like the
                 right attribute and it is not: measured 2026-09-09, the
                 picker injected into the quick-add drawer on
                 /collections/all carries `data-template-product-match="true"`
                 as well, so that test passes on exactly the page this must
                 refuse. The dialog check alone was holding the line; this
                 makes it two independent guards instead of one.
               - an EMPTY form id means the choose-gate is still holding an
                 incomplete selection. Leave the URL alone rather than
                 publishing a half-made choice. */
          function syncUrl() {
            if (picker.closest('dialog, .quick-add-modal')) return;
            var own = picker.getAttribute('data-product-url') || '';
            own = own.split('?')[0].split('#')[0];
            if (!own || window.location.pathname !== own) return;
            var pf = document.querySelector('product-form-component[data-product-id="' + c4Pid + '"]') ||
                     document.querySelector('product-form-component');
            if (!pf) return;
            var idInput = pf.querySelector('input[name="id"]');
            if (!idInput || !idInput.value) return;
            var want = String(idInput.value), u;
            try { u = new URL(window.location.href); } catch (e) { return; }
            if (u.searchParams.get('variant') === want) return;   // idempotent
            u.searchParams.set('variant', want);
            try {
              window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
            } catch (e) {}
          }

          // Block selecting a dead option (capture so it beats Horizon's own
          // handlers), then recompute.
          picker.addEventListener('click', function (e) {
            var deadLabel = e.target.closest && e.target.closest('.variant-option__button-label.c4-dead-combo');
            if (deadLabel) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            markChosen(e);
            setTimeout(recompute, 60);
          }, true);

          /* Code 4 2026-09-14, Gregory: "i dont want any blinks". The 60 ms timer
             left a colour switch showing the old size still picked, with Add to
             cart armed on the old variant, for 50 to 80 ms (UA Assist 2, Shiny
             Black to Matte Black: lens shown at +56 ms, cleared at +126 ms; the
             same on the product page and in the quick-add drawer). Run the
             correction in the change event itself, capture phase, so it lands
             before Horizon's own handler and before the frame paints. Our own
             programmatic click (applyAuto) re-enters here and is skipped; the
             timer stays as the safety net, and recompute is idempotent. */
          picker.addEventListener('change', function (e) {
            markChosen(e);
            if (!C4_PROGRAMMATIC) { try { recompute(); } catch (err) {} }
            setTimeout(recompute, 60);
          }, true);
          document.addEventListener('shopify:section:load', function () { setTimeout(recompute, 60); });

          /* Code 4 2026-09-14: correct Horizon's re-render BEFORE it paints.
             A first-option click makes Horizon fetch the page and morph this
             picker to Shopify's resolved variant, which checks the first value
             of every later group and un-hides it. With nothing in stock down
             that path applyAuto() clears them again, but only on the next 600ms
             tick, so the shopper saw Waist 28 / Inseam 30 appear picked, with
             Add to cart armed, then vanish (Fast-Tac Urban pant, Black: shown
             +253ms, cleared +624ms). Horizon dispatches variant:update on this
             element synchronously after the morph, and a microtask queued here
             runs after every listener of it, product-form's included, and
             before the frame is painted. */
          picker.addEventListener('variant:update', function () { queueMicrotask(recompute); });

          recompute();
          // Safety net for programmatic variant changes / partial re-renders.
          setInterval(recompute, 600);
  }
      

        /* Code 4 — require a full variant choice before "Add to cart".
           While any real (multi-value) option is still unchosen, the add button
           is disabled + relabeled "Select options" and the variant id is blanked,
           so an incomplete (or stale) selection can't be added. As soon as a
           complete variant is chosen, Horizon re-enables the button, refills the
           id, and restores the label on its own — so the complete state is left
           entirely to Horizon and there is nothing to "restore" here. */
  function c4InitChooseGate(picker) {
          if (picker.__c4ChooseGateInit) return;
          picker.__c4ChooseGateInit = true;

          function fieldsets() {
            return Array.prototype.slice.call(
              picker.querySelectorAll('fieldset.variant-option')
            );
          }

          // Every option that is a real choice (2+ buttons) must have a checked
          // radio. Single-value options render without radios and need no choice.
          function allChosen() {
            var fs = fieldsets();
            for (var i = 0; i < fs.length; i++) {
              var radios = fs[i].querySelectorAll('input[type="radio"]');
              if (radios.length > 1 && !fs[i].querySelector('input[type="radio"]:checked')) {
                return false;
              }
            }
            return true;
          }

          function productForm() {
            // Prefer a form inside the picker's own dialog. On a collection page
            // with the quick-add drawer open, a bare document lookup can reach a
            // form outside it. Falls through to the original document-wide
            // lookup, so the product page is unchanged.
            var pid = picker.getAttribute('data-product-id');
            var scope = picker.closest('dialog, .quick-add-modal');
            if (scope) {
              var inScope = (pid && scope.querySelector('product-form-component[data-product-id="' + pid + '"]')) ||
                            scope.querySelector('product-form-component');
              if (inScope) return inScope;
            }
            return (pid && document.querySelector('product-form-component[data-product-id="' + pid + '"]')) ||
                   document.querySelector('product-form-component');
          }

          function gate() {
            var pf = productForm();
            if (!pf) return;
            var btn = pf.querySelector('button[name="add"]');
            if (!btn) return;

            if (allChosen()) {
              // Horizon restores `disabled` and the label because it set them.
              // It never set aria-disabled — WE did — so nothing else removes it,
              // and Horizon's CSS styles [aria-disabled] at opacity .5 with
              // cursor:not-allowed. Left behind, it made a clickable Add to cart
              // look dead at the exact moment the shopper was ready to buy.
              //
              // Clear ONLY what this gate set, tracked on the element. Horizon
              // legitimately sets aria-disabled for a sold-out or invalid
              // combination; removing that one would make an unbuyable button
              // look buyable, which is worse than the bug being fixed.
              if (btn.__c4GateSetAria) {
                btn.removeAttribute('aria-disabled');
                btn.__c4GateSetAria = false;
              }
              return;
            }

            var idInput = pf.querySelector('input[name="id"]');
            var label = btn.querySelector('.add-to-cart-text__content');
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
            btn.__c4GateSetAria = true;
            if (label) label.textContent = 'Select options';
            if (idInput) idInput.value = '';
          }

          // Code 4 2026-09-14: gate at the change itself, before paint, for the same
          // reason as the swatches' change hook; the 80 ms timer stays as the net.
          picker.addEventListener('change', function () { gate(); setTimeout(gate, 80); }, true);
          picker.addEventListener('click', function () { setTimeout(gate, 80); }, true);
          document.addEventListener('shopify:section:load', function () { setTimeout(gate, 80); });
          // Same reason as recompute's variant:update hook: product-form re-arms
          // Add to cart inside that event, so re-gate before the frame paints.
          picker.addEventListener('variant:update', function () { queueMicrotask(gate); });

          gate();
          // Safety net against any late re-init that re-fills the default variant.
          setInterval(gate, 500);
  }
      

  // Wire every picker on the page, however it got there. The 500ms scan is what
  // catches a picker injected into the quick-add drawer, which never parses its
  // own scripts. The per-element __c4*Init guards make repeat scans a no-op.
  function c4ScanPickers() {
    var pickers = document.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) {
      try { c4InitSwatches(pickers[i]); } catch (e) {}
      try { c4InitChooseGate(pickers[i]); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', c4ScanPickers);
  } else {
    c4ScanPickers();
  }
  document.addEventListener('shopify:section:load', c4ScanPickers);
  setInterval(c4ScanPickers, 500);
})();
